/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Grid_ColumnsInputs */

const cs_builder_grid_columns = /** @type {(inputs: Builder_Grid_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sloupce`)
};

const en_builder_grid_columns = /** @type {(inputs: Builder_Grid_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Columns`)
};

/**
* | output |
* | --- |
* | "Columns" |
*
* @param {Builder_Grid_ColumnsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_grid_columns = /** @type {((inputs?: Builder_Grid_ColumnsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Grid_ColumnsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_grid_columns(inputs)
	return cs_builder_grid_columns(inputs)
});